<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.amzFirstDemandNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.amzFirstDemandStatus == 'Y'
              ? 'success'
              : formData.amzFirstDemandStatus == 'F'
              ? 'info'
              : formData.amzFirstDemandStatus == 'S'
              ? 'warning'
              : formData.amzFirstDemandStatus == 'D'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_amzFirstDemandStatus || 'New' }}
        </el-tag>
        <el-divider
          v-if="formData.v_skuSalesChannel"
          direction="vertical"
        ></el-divider>
        <el-tag
          v-if="formData.v_skuSalesChannel"
          size="mini"
          :type="formData.skuSalesChannel == 'V' ? 'warning' : ''"
        >
          {{ formData.v_skuSalesChannel || '' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_title') || '标题'">
            <el-input
              v-model="formData.title"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') || '自动生成'
              "
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_designName') || '负责企划'"
            prop="designCode"
          >
            <dict-select
              v-if="!disabled && !prohibit"
              v-model="formData.designCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              :selectedLabel.sync="formData.designName"
            />
            <el-input v-else v-model="formData.designName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_operateName') || '负责运营'"
            prop="operateCode"
          >
            <dict-select
              v-if="!disabled && !prohibit"
              v-model="formData.operateCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              :selectedLabel.sync="formData.operateName"
            />

            <el-input v-else v-model="formData.operateName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item :label="''">
            <br />
            <el-button
              v-if="!disabled && !prohibit"
              type="primary"
              size="mini"
              @click="save()"
              style="width: 100%"
              >{{ $l('INDEX.btn_save') || '保存' }}</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SkuTable
      ref="skuTable"
      class="mt-1"
      :amzFirstDemandCode="amzFirstDemandCode"
      :isVcList="[formData.skuSalesChannel === 'V' ? 'Y' : 'N']"
      :disabled="disabled"
      :prohibit="prohibit"
      :designDisabled="designDisabled"
      :operateDisabled="operateDisabled"
      @reset="getData"
    />
    <PromotionTable
      :amzFirstDemandCode="amzFirstDemandCode"
      disabled
    ></PromotionTable>
    <ReviewTable
      ref="ReviewTable"
      class="mt-1"
      :amzFirstDemandCode="amzFirstDemandCode"
      :disabled="disabledPredict"
      @reset="getData"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
import PromotionTable from '../promotion-table'
import ReviewTable from '../review-table'
export default {
  mixins: [EditLoading],
  components: { SkuTable, ReviewTable, PromotionTable },
  props: {
    amzFirstDemandCode: { type: String, default: '' },
    pageType: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: { operateCode: '', designCode: '', amzFirstDemandStatus: 'N' },
      rules: {
        designCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        operateCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
    prohibit() {
      return this.formData.amzFirstDemandStatus != 'N'
    },
    designDisabled() {
      return (
        this.formData.amzFirstDemandStatus != 'R' &&
        this.formData.amzFirstDemandStatus != 'N'
      )
    },
    operateDisabled() {
      return this.formData.amzFirstDemandStatus != 'S'
    },
    disabledPredict() {
      return this.disabled
    },
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.amzFirstDemandCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.designCode = userCode || ''
        this.formData.designName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      if (!this.amzFirstDemandCode) return
      const res = await this.$api
        .ecomAmzFirstDemandDetailApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      const params = { ...this.formData }
      const res = await this.$api
        .ecomAmzFirstDemandSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.amzFirstDemandCode) {
        this.getData()
        return
      }

      const { amzFirstDemandCode = '', amzFirstDemandNo = '' } = body || {}
      if (amzFirstDemandCode) {
        this.$router.replace({
          name: 'ecom-awsBiz-skuFirstOrder-detail',
          params: { amzFirstDemandCode, pageType: 'edit' },
          query: { amzFirstDemandNo },
        })
        return
      }
    },
    async validate() {
      const skuResult = this.$refs.skuTable.validate()
      return skuResult
    },

    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.span-style {
  font-size: 30px;
  line-height: 22px;
  color: #888888;
}
</style>
